export const GLOBAL_PORTAL_DATA_UPDATE = "GLOBAL_PORTAL_DATA_UPDATE";

export function actionGlobalPortalDataUpdate(data) {
    return { type: GLOBAL_PORTAL_DATA_UPDATE, data };
}